import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { UserNotificationsService } from './user-notifications.service';

export const provideUserNotifications = (): EnvironmentProviders => {
    return makeEnvironmentProviders([
        provideEnvironmentInitializer(() => {
            inject(UserNotificationsService);
        })
    ]);
};
